"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reflux = _interopRequireDefault(require("reflux"));

var _AppNativeStorage = _interopRequireDefault(require("../../../../utils/AppNativeStorage"));

var _RelevancesActions = _interopRequireDefault(require("./RelevancesActions"));

var _KesiConstants = require("../../../KesiConstants");

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

/** @namespace Reflux.Store */
var RelevancesStore = /*#__PURE__*/function (_Reflux$Store) {
  (0, _inherits2["default"])(RelevancesStore, _Reflux$Store);

  var _super = _createSuper(RelevancesStore);

  function RelevancesStore() {
    var _this;

    (0, _classCallCheck2["default"])(this, RelevancesStore);
    _this = _super.call(this);
    _this.listenables = _RelevancesActions["default"];
    _this.state = {
      availableAspects: [],
      currentAspect: null,
      relevances: {}
    };
    return _this;
  }

  (0, _createClass2["default"])(RelevancesStore, [{
    key: "initFromPersistentStore",
    value: function () {
      var _initFromPersistentStore = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _AppNativeStorage["default"].getValue(_AppNativeStorage["default"].KEYS.CURRENT_ASPECT);

              case 3:
                this.state.currentAspect = _context.sent;
                _context.next = 6;
                return _AppNativeStorage["default"].getValue(_AppNativeStorage["default"].KEYS.ASPECTS);

              case 6:
                this.state.availableAspects = _context.sent;
                _context.next = 9;
                return _AppNativeStorage["default"].getValue(_AppNativeStorage["default"].KEYS.RELEVANCES);

              case 9:
                this.state.relevances = _context.sent;
                return _context.abrupt("return", _promise["default"].resolve());

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function initFromPersistentStore() {
        return _initFromPersistentStore.apply(this, arguments);
      }

      return initFromPersistentStore;
    }()
  }, {
    key: "onRemoveAspectsExcept",
    value: function onRemoveAspectsExcept(keptAspects) {
      var _this2 = this;

      (0, _keys["default"])(this.state.relevances).forEach(function (key) {
        if (keptAspects.includes(key)) {
          delete _this2.state.relevances[key];
        }
      });
    }
  }, {
    key: "onSetAvailableAspects",
    value: function onSetAvailableAspects(availableAspects) {
      console.log('RelevancesStore - onSetAvailableAspects', availableAspects);
      this.state.availableAspects = availableAspects;

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.ASPECTS, this.state.availableAspects);

      this.trigger(this.state);
    }
  }, {
    key: "onSetAvailableAspectsAndRelevances",
    value: function onSetAvailableAspectsAndRelevances(availableAspects, relevances) {
      console.log('RelevancesStore - onSetAvailableAspectsAndRelevances', availableAspects, relevances);
      this.state.availableAspects = availableAspects;
      this.state.relevances = relevances;

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.ASPECTS, this.state.availableAspects);

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.RELEVANCES, this.state.relevances);

      this.trigger(this.state);
    }
  }, {
    key: "onSetCurrentAspect",
    value: function onSetCurrentAspect(aspect) {
      console.log('RelevancesStore - onSetCurrentAspect', aspect);
      this.state.currentAspect = aspect;

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.CURRENT_ASPECT, this.state.currentAspect);

      this.trigger(this.state);
    }
  }, {
    key: "onSetRelevances",
    value: function onSetRelevances(relevances) {
      // put root id in front of every path that starts with the KESI_PATH_DELIMITER
      var re = new RegExp("\"".concat(_KesiConstants.KESI_PATH_DELIMITER), 'g');
      var relevancesToUse = JSON.parse((0, _stringify["default"])(relevances).replace(re, "\"".concat(_config["default"].rootId).concat(_KesiConstants.KESI_PATH_DELIMITER)));
      console.log('RelevancesStore - onSetRelevances', {
        incomingRelevances: relevances,
        processedRelevances: relevancesToUse
      });
      this.state.relevances = (0, _assign["default"])({}, this.state.relevances, relevancesToUse); // merge with existing

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.RELEVANCES, this.state.relevances);

      this.trigger(this.state);
    }
  }]);
  return RelevancesStore;
}(_reflux["default"].Store);

RelevancesStore.id = 'relevancesStore';
var _default = RelevancesStore;
exports["default"] = _default;